export default "__VITE_ASSET__Csoy0QRC__"